/* RESPONSIBLE TEAM: team-automation-foundations */
import { helper } from '@ember/component/helper';
import { VOICE_UNSUPPORTED_CATEGORIES } from 'embercom/components/ai-agent/guidance/channel-group-selector';

const isVoiceUnsupportedCategoryHelper = helper(function isVoiceUnsupportedCategory([category]: [
  string,
]) {
  return VOICE_UNSUPPORTED_CATEGORIES.includes(category as any);
});

export default isVoiceUnsupportedCategoryHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-voice-unsupported-category': typeof isVoiceUnsupportedCategoryHelper;
  }
}
